var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.223 5.395 6.5-5.323A1.111 1.111 0 0 0 13.334 0H1.112C.979 0 .847.025.722.072l6.5 5.323Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.572 6.539a.61.61 0 0 1-.077.05l-.062.033a.556.556 0 0 1-.21.045.556.556 0 0 1-.212-.045l-.06-.033a.611.611 0 0 1-.079-.05L0 .933V8.89a1.111 1.111 0 0 0 1.111 1.11h12.223a1.111 1.111 0 0 0 1.11-1.11V.933L7.573 6.54Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMail);
export default __webpack_public_path__ + "static/media/white-mail.3f8b684788d603eabab9b72ec1ec9a06.svg";
export { ForwardRef as ReactComponent };